import {
	useMemo,
	useState,
} from "react";

import {
	Avatar,
	Box,
	Button,
	Dialog,
	DialogContent,
	Fade,
	LinearProgress,
	Stack,
	Typography,
} from "@mui/material";

import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import MarceloAvatar from "../../assets/img/img-marcelo.png";


const MARCELO_AVATAR =
	MarceloAvatar;


const QUESTIONS = [
	{
		question:
			"Quem é o melhor programador que existe?",
	},
	{
		question:
			"Quem é o cara mais bonito que existe?",
	},
	{
		question:
			"Quem é o mais inteligente?",
	},
	{
		question:
			"Quem é o mais forte?",
	},
	{
		question:
			"Quem é o cara que eu mais amo no mundo?",
	},
	{
		question:
			"Quem é o mais legal?",
	},
];


const FUNNY_BUTTON_POSITIONS = [
	{
		left: "2%",
		top: "4px",
	},
	{
		left: "38%",
		top: "4px",
	},
	{
		right: "2%",
		top: "4px",
	},
	{
		left: "2%",
		top: "125px",
	},
	{
		left: "38%",
		top: "125px",
	},
	{
		right: "2%",
		top: "125px",
	},
];


const FunSurpriseModal = ({
	open,
	onClose,
}) => {
	const [
		step,
		setStep,
	] = useState(0);

	const [
		finishedQuestions,
		setFinishedQuestions,
	] = useState(false);

	const [
		funnyButtonPosition,
		setFunnyButtonPosition,
	] = useState(1);


	const currentQuestion =
		QUESTIONS[step];


	const totalSteps =
		QUESTIONS.length + 1;


	const currentProgress =
		useMemo(() => {
			if (
				finishedQuestions
			) {
				return 100;
			}

			return (
				((step + 1) /
					totalSteps) *
				100
			);
		}, [
			step,
			finishedQuestions,
			totalSteps,
		]);


	function handleAnswer() {
		const isLastQuestion =
			step ===
			QUESTIONS.length - 1;

		if (
			isLastQuestion
		) {
			setFinishedQuestions(
				true
			);

			return;
		}

		setStep(
			(current) =>
				current + 1
		);

		moveFunnyButton();
	}


	function moveFunnyButton() {
		setFunnyButtonPosition(
			(current) => {
				let next =
					current;

				while (
					next === current
				) {
					next =
						Math.floor(
							Math.random() *
								FUNNY_BUTTON_POSITIONS.length
						);
				}

				return next;
			}
		);
	}


	function handleFunnyButtonClick(
		event
	) {
		event.preventDefault();
		event.stopPropagation();

		try {
			window.open(
				"",
				"_self"
			);

			window.close();
		} catch (error) {
			console.log(
				"Não foi possível fechar a aba:",
				error
			);
		}

		setTimeout(() => {
			try {
				window.location.replace(
					"about:blank"
				);
			} catch (error) {
				console.log(
					"Não foi possível substituir a página:",
					error
				);
			}
		}, 80);
	}


	function handleFinish() {
		onClose?.();
	}


	const funnyPosition =
		FUNNY_BUTTON_POSITIONS[
			funnyButtonPosition
		];


	return (
		<Dialog
			open={open}
			fullScreen
			disableEscapeKeyDown
			TransitionComponent={
				Fade
			}
			PaperProps={{
				sx: {
					background:
						"linear-gradient(145deg, #170b12 0%, #24101b 50%, #11080e 100%)",

					color:
						"#ffffff",
				},
			}}
		>
			<DialogContent
				sx={{
					p: 0,

					minHeight:
						"100vh",

					display:
						"flex",

					alignItems:
						"center",

					justifyContent:
						"center",

					position:
						"relative",

					overflow:
						"hidden",
				}}
			>
				<Box
					sx={{
						position:
							"absolute",

						width:
							420,

						height:
							420,

						borderRadius:
							"50%",

						background:
							"rgba(221, 86, 143, 0.10)",

						filter:
							"blur(20px)",

						top:
							-180,

						right:
							-100,
					}}
				/>

				<Box
					sx={{
						position:
							"absolute",

						width:
							360,

						height:
							360,

						borderRadius:
							"50%",

						background:
							"rgba(255, 255, 255, 0.04)",

						bottom:
							-160,

						left:
							-100,
					}}
				/>


				<Box
					sx={{
						position:
							"relative",

						zIndex: 2,

						width:
							"100%",

						maxWidth:
							620,

						px: {
							xs: 2.5,
							sm: 4,
						},
					}}
				>
					<Stack
						spacing={4}
					>
						<Stack
							spacing={1}
						>
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="space-between"
							>
								<Stack
									direction="row"
									spacing={1}
									alignItems="center"
								>
									<LockOutlinedIcon
										sx={{
											fontSize:
												18,

											opacity:
												0.7,
										}}
									/>

									<Typography
										variant="caption"
										fontWeight={800}
										sx={{
											letterSpacing:
												1,

											textTransform:
												"uppercase",

											opacity:
												0.65,
										}}
									>
										Verificação de acesso
									</Typography>
								</Stack>

								<Typography
									variant="caption"
									sx={{
										opacity:
											0.6,
									}}
								>
									{finishedQuestions
										? totalSteps
										: step + 1}

									{" / "}

									{totalSteps}
								</Typography>
							</Stack>


							<LinearProgress
								variant="determinate"
								value={
									currentProgress
								}
								sx={{
									height: 6,

									borderRadius:
										999,

									backgroundColor:
										"rgba(255,255,255,0.08)",

									"& .MuiLinearProgress-bar":
										{
											borderRadius:
												999,

											background:
												"#dd568f",
										},
								}}
							/>
						</Stack>


						{!finishedQuestions ? (
							<Stack
								spacing={3.5}
								alignItems="center"
								textAlign="center"
							>
								<Box
									sx={{
										position:
											"relative",

										display:
											"flex",

										alignItems:
											"center",

										justifyContent:
											"center",
									}}
								>
									<Box
										sx={{
											position:
												"absolute",

											width:
												150,

											height:
												150,

											borderRadius:
												"50%",

											background:
												"rgba(221,86,143,0.18)",

											filter:
												"blur(15px)",
										}}
									/>

									<Avatar
										src={
											MARCELO_AVATAR
										}
										alt="Marcelo"
										sx={{
											width: {
												xs:
													120,

												sm:
													140,
											},

											height: {
												xs:
													120,

												sm:
													140,
											},

											border:
												"4px solid rgba(241,138,181,0.8)",

											boxShadow:
												"0 18px 50px rgba(0,0,0,0.35)",

											zIndex: 1,
										}}
									/>
								</Box>


								<Stack
									spacing={1.5}
								>
									<Typography
										variant="h4"
										fontWeight={900}
										sx={{
											lineHeight:
												1.2,

											maxWidth:
												560,
										}}
									>
										{
											currentQuestion.question
										}
									</Typography>

									<Typography
										variant="body2"
										sx={{
											opacity:
												0.5,
										}}
									>
										Escolha com bastante cuidado.
									</Typography>
								</Stack>


								<Box
									sx={{
										width:
											"100%",

										maxWidth:
											440,

										height:
											180,

										position:
											"relative",
									}}
								>
									<Box
										sx={{
											position:
												"absolute",

											top: 48,

											left:
												"50%",

											transform:
												"translateX(-50%)",

											width:
												260,

											height:
												58,

											zIndex: 2,
										}}
									>
										<Button
											fullWidth
											variant="contained"
											onClick={
												handleAnswer
											}
											startIcon={
												<AutoAwesomeIcon
													sx={{
														fontSize:
															20,
													}}
												/>
											}
											sx={{
												height:
													58,

												borderRadius:
													2.5,

												textTransform:
													"none",

												fontWeight:
													950,

												fontSize:
													18,

												background:
													"#dd568f",

												boxShadow:
													"0 10px 28px rgba(221,86,143,0.25)",

												"& .MuiButton-startIcon":
													{
														marginRight:
															"7px",
													},

												"&:hover":
													{
														background:
															"#c94b80",

														transform:
															"translateY(-1px)",
													},

												transition:
													"all 0.15s ease",
											}}
										>
											Marcelo
										</Button>
									</Box>


									<Button
										variant="outlined"
										tabIndex={-1}
										onPointerEnter={
											moveFunnyButton
										}
										onMouseEnter={
											moveFunnyButton
										}
										onTouchStart={
											moveFunnyButton
										}
										onFocus={(
											event
										) => {
											event
												.currentTarget
												.blur();

											moveFunnyButton();
										}}
										onClick={
											handleFunnyButtonClick
										}
										sx={{
											position:
												"absolute",

											left:
												funnyPosition.left ??
												"auto",

											right:
												funnyPosition.right ??
												"auto",

											top:
												funnyPosition.top,

											minWidth:
												90,

											height:
												34,

											px: 1.4,

											borderRadius:
												2,

											textTransform:
												"none",

											fontSize:
												12,

											fontWeight:
												800,

											color:
												"rgba(255,255,255,0.48)",

											borderColor:
												"rgba(255,255,255,0.16)",

											background:
												"rgba(255,255,255,0.025)",

											userSelect:
												"none",

											WebkitUserSelect:
												"none",

											zIndex: 3,

											transition:
												"all 0.1s ease",

											"&:hover":
												{
													borderColor:
														"rgba(255,255,255,0.18)",

													background:
														"rgba(255,255,255,0.04)",
												},
										}}
									>
										Bernardo
									</Button>
								</Box>
							</Stack>
						) : (
							<Stack
								spacing={3.5}
								alignItems="center"
								textAlign="center"
							>
								<Box
									sx={{
										width:
											76,

										height:
											76,

										borderRadius:
											3,

										display:
											"flex",

										alignItems:
											"center",

										justifyContent:
											"center",

										background:
											"rgba(221,86,143,.14)",

										border:
											"1px solid rgba(221,86,143,.3)",
									}}
								>
									<EmojiEventsOutlinedIcon
										sx={{
											fontSize:
												38,

											color:
												"#f18ab5",
										}}
									/>
								</Box>


								<Stack
									spacing={1.5}
								>
									<Typography
										variant="h3"
										fontWeight={900}
									>
										Parabéns, Bernardo.
									</Typography>

									<Typography
										variant="h6"
										fontWeight={700}
										sx={{
											lineHeight:
												1.5,

											opacity:
												0.9,
										}}
									>
										Você acertou absolutamente todas.
									</Typography>
								</Stack>


								<Box
									sx={{
										width:
											"100%",

										p: 3,

										borderRadius:
											3,

										background:
											"rgba(255,255,255,0.05)",

										border:
											"1px solid rgba(255,255,255,0.09)",
									}}
								>
									<FavoriteRoundedIcon
										sx={{
											color:
												"#f18ab5",

											mb: 1.5,
										}}
									/>

									<Typography
										variant="h6"
										fontWeight={800}
										sx={{
											lineHeight:
												1.55,
										}}
									>
										Agora falta apenas o último passo para liberar o acesso:
									</Typography>

									<Typography
										variant="h6"
										fontWeight={900}
										sx={{
											lineHeight:
												1.55,

											mt: 1.5,
										}}
									>
										compartilhe todas as suas respostas nas suas redes sociais e marque{" "}

										<Box
											component="span"
											sx={{
												color:
													"#f18ab5",

												fontWeight:
													950,
											}}
										>
											@marcelo.pata
										</Box>

										.
									</Typography>
								</Box>


								<Typography
									variant="body2"
									sx={{
										opacity:
											0.45,
									}}
								>
									Obviamente este procedimento será auditado com extremo rigor.
								</Typography>


								<Button
									fullWidth
									variant="contained"
									onClick={
										handleFinish
									}
									sx={{
										height:
											54,

										maxWidth:
											420,

										borderRadius:
											2.5,

										textTransform:
											"none",

										fontWeight:
											900,

										fontSize:
											16,

										background:
											"#dd568f",

										"&:hover":
											{
												background:
													"#c94b80",
											},
									}}
								>
									Já compartilhei, liberar acesso
								</Button>
							</Stack>
						)}
					</Stack>
				</Box>
			</DialogContent>
		</Dialog>
	);
};


export default FunSurpriseModal;